import {FaCirclePlus} from 'react-icons/fa6';
import {COLOR_WHITE} from '../../../../../config/constants/colorCodes';

type Props = {
  onClick: () => void;
};

export const PostButton: React.FC<Props> = ({onClick}) => {
  return (
    <button
      className="w-[116px] py-12 px-16 bg-primary-1 rounded-full flex justify-start items-center hover:opacity-80"
      onClick={onClick}
    >
      <FaCirclePlus size={20} fill={COLOR_WHITE} />
      <span className="text-base text-white font-bold ml-8">投稿する</span>
    </button>
  );
};
